import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { H5 } from '../../../AbstractElements';
import { Description } from '../../../Constant';
import { BrandIconSelect, ColorSelect, ProductCategorySelect, QualitySelect } from '../../../Data/Ecommerce/ProductPage';
import InputControl from '../../Common/FormInputs/InputControl';

const LeftForm = ({ errors, control, register }) => {
  return (
    <>
      <Col xl='6'>
        <Card>
          <CardBody>
            <div className='product-info'>
              <H5>{Description}</H5>
              <div className='product-group'>
                <Row>
                  <Col sm='12'>
                    <InputControl controlInput='input' className='form-control' type='text' errors={errors} placeholder='Enter Project Name *' register={{ ...register('product_name', { required: 'is Required.' }) }} />
                  </Col>
                  <Col sm='12'>
                    <InputControl controlInput='textarea' row='2' className='form-control' type='text' errors={errors} placeholder='Enter Product Description *' register={{ ...register('product_description', { required: 'is Required.' }) }} />
                  </Col>
                </Row>
              </div>
              <H5 className='mt-4'>{Description}</H5>
              <div className='product-group'>
                <Row>
                  <Col sm='12'>
                    <InputControl control={control} controlInput='select' options={ProductCategorySelect} className='form-select' errors={errors} register={{ ...register('product_category', { required: 'is Required.' }) }} />
                  </Col>
                  <Col sm='6'>
                    <InputControl control={control} controlInput='select' options={BrandIconSelect} className='form-select' errors={errors} register={{ ...register('brand_icons', { required: 'is Required.' }) }} />
                  </Col>
                  <Col sm='6'>
                    <InputControl control={control} controlInput='select' options={ColorSelect} className='form-select' errors={errors} register={{ ...register('color', { required: 'is Required.' }) }} />
                  </Col>
                  <Col sm='12'>
                    <InputControl control={control} controlInput='select' options={QualitySelect} className='form-select' errors={errors} register={{ ...register('quality', { required: 'is Required.' }) }} />
                  </Col>
                </Row>
              </div>
            </div>
          </CardBody>
        </Card>
      </Col>
    </>
  );
};

export default LeftForm;
